import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { captureUtms, track } from "../../lib/track";

const GA_ID = "G-65ZQ4VL9K4";

const verticalFromPath = (p) => {
  if (p.startsWith("/dental")) return "dental";
  if (p.startsWith("/consulting")) return "consulting";
  if (p.startsWith("/creative")) return "publishing";
  return "general";
};

const waSource = (id) => {
  if (!id) return "unknown";
  if (id === "floating-whatsapp") return "floating";
  if (id.startsWith("whatsapp-cta-")) return id.replace("whatsapp-cta-", "");
  if (id.startsWith("nav-")) return "nav";
  if (id.startsWith("contact-success")) return "contact-form-success";
  if (id.startsWith("contact-")) return "contact-page";
  if (id.startsWith("aira-")) return "aira";
  return id;
};

export const AnalyticsTracker = () => {
  const location = useLocation();
  const lastView = useRef("");
  const configured = useRef(false);

  useEffect(() => {
    captureUtms();
    const onClick = (e) => {
      if (window.location.pathname.startsWith("/admin")) return;
      const anchor = e.target.closest?.("a[href]");
      if (!anchor) return;
      if (/wa\.me|whatsapp\.com/.test(anchor.href || "")) {
        const linkId = anchor.getAttribute("data-testid") || "wa-link";
        track("whatsapp_click", {
          page: window.location.pathname,
          vertical: verticalFromPath(window.location.pathname),
          link_id: linkId,
          source: waSource(linkId),
        });
      }
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    const key = location.pathname + location.search;
    if (lastView.current === key) return;
    lastView.current = key;
    if (typeof window.gtag === "function") {
      if (!configured.current) {
        configured.current = true;
        window.gtag("config", GA_ID, { send_page_view: false });
      }
      window.gtag("event", "page_view", {
        page_path: key,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location]);

  return null;
};
